import { acervoApi } from "../axios";

// LISTAGEM
export function getPublicacoes(
    busca: string = "",
    categorias: number[] = [],
    subcategorias: number[] = [],
    editoras: number[] = [],
    notas: number[] = [],
    ordenacao: number = 1,
    pagina: number = 1,
    quantidade: number = 10,
    produtoId: number = 1
) {
    const params = new URLSearchParams();

    if (busca) params.append("search", busca);
    categorias.forEach((categoria) => params.append("categorias", categoria.toString()));
    subcategorias.forEach((subcategoria) => params.append("subcategorias", subcategoria.toString()));
    editoras.forEach((editora) => params.append("editoras", editora.toString()));
    notas.forEach((nota) => params.append("notas", nota.toString()));
    params.append("ordenacao", ordenacao.toString());
    params.append("pagina", pagina.toString());
    params.append("quantidade", quantidade.toString());
    params.append("produtoId", produtoId.toString());

    return acervoApi.get(`?${params.toString()}`);
}

export function getCategorias(produtoId: number = 1) {
    return acervoApi.get(`/Categorias?produtoId=${produtoId}`);
}

export function getSubcategorias(categoriasIds: number[] = [], produtoId: number = 1) {
    const params = new URLSearchParams();

    categoriasIds.forEach((categoriaId) => params.append("categoriaPaiIds", categoriaId.toString()));

    params.append("produtoId", produtoId.toString());

    return acervoApi.get(`/Categorias/Filhas?${params.toString()}`);
}

export function getEditoras(produtoId: number = 1) {
    return acervoApi.get(`/Selos?produtoId=${produtoId}`);
}

// DETALHES
export function getPublicacao(publicacaoId: number, produtoId: number = 1) {
    return acervoApi.get(`/Detalhe?publicacaoId=${publicacaoId}&produtoId=${produtoId}`);
}

export function getPublicacoesSimilares(publicacaoId: number, produtoId: number = 1, quantidade: number = 5) {
    return acervoApi.get(`/Detalhe/LivrosSimilares?publicacaoId=${publicacaoId}&produtoId=${produtoId}&quantidade=${quantidade}`);
}